import React from 'react';

export function FlagComponent({
  locale,
  text
}: {
  locale: string,
  text?: string | undefined
}) {
  return (
    <>
      <span data-flag={ locale }>{ text || "" }</span>
    </>
  );
}
